import { formatDateTime } from "@/utils/datetime";
import { z } from "zod";

export const NullableString = z.string().nullable();
export const NullableStringWithDefault = (defaultValue: string) =>
  z
    .string()
    .nullable()
    .transform((value) => value ?? defaultValue);
export const TruthyBool = z
  .boolean()
  .nullish()
  .transform((value) => value ?? true);
export const FalsyBool = z
  .boolean()
  .nullish()
  .transform((value) => value ?? false);

export const NullableNumber = z.number().nullable();
export const NullableNumberWithDefault = (defaultValue: number) =>
  z
    .number()
    .nullable()
    .transform((value) => value ?? defaultValue);

export const DateString = z.string().transform((value) => new Date(value));
export const DateTimeStringWithOffset = z.string().datetime({ offset: true });
export const DateTimeWithOffset = DateTimeStringWithOffset.transform((value) => ({
  date: new Date(value),
  formatted: formatDateTime(value),
}));

export const NullishDateTimeWithOffset = z
  .string()
  .datetime({ offset: true })
  .nullish()
  .transform((value) =>
    value
      ? {
          date: new Date(value),
          formatted: formatDateTime(value),
        }
      : undefined,
  );
